<template>
  <div class="mall-h5">
    <!-- 品牌头 -->
    <div class="mh5-banner">
      <div class="mh5-banner__pattern" />
      <div v-if="verifiedPhone" class="mh5-banner__phone" @click="switchPhone">
        <van-icon name="phone-o" />
        <span>****{{ verifiedPhone.slice(-4) }}</span>
        <van-icon name="replay" />
      </div>
      <div class="mh5-banner__content">
        <img class="mh5-banner__logo-img" src="@/assets/hongJiTang_banner2.png" alt="宏济堂" />
      </div>
      <div class="mh5-banner__decor">
        <span class="mh5-banner__decor-dot" />
        <span class="mh5-banner__decor-dot" />
        <span class="mh5-banner__decor-line" />
      </div>
    </div>

    <!-- 验证区 -->
    <div v-if="!verifiedPhone" class="mh5-verify">
      <div class="mh5-verify__card">
        <div class="mh5-verify__icon">
          <van-icon name="description" />
        </div>
        <div class="mh5-verify__title">查询我的订单</div>
        <div class="mh5-verify__desc">请输入下单时填写的收货手机号<br/>验证后即可查看该手机号下的全部订单</div>
        <div class="mh5-verify__form">
          <div class="mh5-field">
            <van-icon name="phone-o" />
            <input v-model="phone" type="tel" maxlength="11" placeholder="请输入收货手机号" />
          </div>
          <div class="mh5-field mh5-field--code">
            <van-icon name="manager-o" />
            <input v-model="code" type="tel" maxlength="6" placeholder="短信验证码" />
            <button class="mh5-codebtn" :disabled="counting || !phoneOk" @click="onSendCode">
              {{ counting ? `${seconds}s` : '获取验证码' }}
            </button>
          </div>
          <button class="mh5-submit" :disabled="!phoneOk || code.length !== 6 || submitting" @click="onVerify">
            <span v-if="!submitting">查询订单</span>
            <span v-else>查询中...</span>
          </button>
        </div>
      </div>
    </div>

    <!-- 订单列表 -->
    <div v-else class="mh5-orders">
      <div v-if="loading" style="text-align:center;padding:20px"><van-loading /></div>
      <div v-if="!loading && list.length === 0" class="mh5-empty">
        <div class="mh5-empty__icon"><van-icon name="orders-o" /></div>
        <div class="mh5-empty__text">暂无订单</div>
        <div class="mh5-empty__hint">该手机号下还没有订单记录</div>
      </div>

      <div v-for="o in list" :key="o.id" class="mh5-order" @click="goDetail(o)">
        <div class="mh5-order__head">
          <span class="mh5-order__no">订单号：{{ o.orderNo }}</span>
          <span :class="['mh5-order__status', statusClass(o.orderStatus)]">{{ statusName(o.orderStatus) }}</span>
        </div>
        <div class="mh5-order__foot">
          <span class="mh5-order__time">{{ formatTime(o.createTime) }}</span>
          <span class="mh5-order__total">合计 <b>¥{{ o.totalAmount }}</b></span>
          <van-icon name="arrow" class="mh5-order__arrow" />
        </div>
      </div>

      <div v-if="list.length && list.length < total" class="mh5-more" @click="loadMore">
        <span>查看更多订单</span><van-icon name="arrow-down" />
      </div>
    </div>

    <div class="mh5-safe-bottom" />
  </div>
</template>

<script>
import { mallH5OrderSendCode, mallH5OrderListByPhone } from '@/api/mall'

const PHONE_KEY = 'mall_inquiry_phone'
const STATUS_MAP = {
  0: { name: '待支付', cls: 'is-wait' },
  1: { name: '已支付', cls: 'is-paid' },
  2: { name: '已发货', cls: 'is-ship' },
  3: { name: '已退单', cls: 'is-refund' },
  4: { name: '已取消', cls: 'is-cancel' },
  5: { name: '待确认', cls: 'is-confirm' }
}

export default {
  name: 'MallH5Inquiry',
  data() {
    return {
      phone: '',
      code: '',
      counting: false,
      seconds: 60,
      timer: null,
      submitting: false,
      loading: false,
      verifiedPhone: '',
      list: [],
      page: { pageCurrent: 1, pageSize: 10 },
      total: 0
    }
  },
  computed: {
    phoneOk() {
      return /^1\d{10}$/.test(this.phone)
    }
  },
  created() {
    const cached = localStorage.getItem(PHONE_KEY)
    if (cached) {
      this.verifiedPhone = cached
      this.fetchList()
    }
  },
  beforeDestroy() {
    if (this.timer) clearInterval(this.timer)
  },
  methods: {
    statusName(s) { return (STATUS_MAP[s] || {}).name || '未知' },
    statusClass(s) { return (STATUS_MAP[s] || {}).cls || '' },
    itemCount(o) {
      return (o.orderItems || []).reduce((n, it) => n + (it.quantity || 0), 0)
    },
    goDetail(o) {
      if (!o || !o.orderNo) return
      // 缓存列表订单(含商品明细)作为详情兜底,防止详情接口未返回 orderItems
      sessionStorage.setItem('mall_order_preview', JSON.stringify(o))
      this.$router.push({ path: '/h5/mall/orderDetail', query: { orderNo: o.orderNo } })
    },
    formatTime(t) {
      if (!t) return ''
      return String(t).replace('T', ' ').substring(0, 16)
    },
    onSendCode() {
      if (!this.phoneOk || this.counting) return
      mallH5OrderSendCode({ userPhone: this.phone }).then(() => {
        this.$toast('验证码已发送')
        this.startCount()
      })
    },
    startCount() {
      this.counting = true
      this.seconds = 60
      if (this.timer) clearInterval(this.timer)
      this.timer = setInterval(() => {
        this.seconds -= 1
        if (this.seconds <= 0) {
          this.counting = false
          clearInterval(this.timer)
        }
      }, 1000)
    },
    onVerify() {
      if (!this.phoneOk || this.code.length !== 6 || this.submitting) return
      this.submitting = true
      mallH5OrderListByPhone({
        receiverPhone: this.phone,
        securityCode: this.code,
        pageCurrent: 1,
        pageSize: this.page.pageSize
      }).then(res => {
        this.verifiedPhone = this.phone
        localStorage.setItem(PHONE_KEY, this.phone)
        this.page.pageCurrent = 1
        this.list = (res.data && res.data.records) || []
        this.total = (res.data && res.data.total) || 0
      }).finally(() => { this.submitting = false })
    },
    fetchList(append = false) {
      this.loading = true
      const pageCurrent = append ? this.page.pageCurrent : 1
      mallH5OrderListByPhone({
        receiverPhone: this.verifiedPhone,
        pageCurrent,
        pageSize: this.page.pageSize
      }).then(res => {
        const records = (res.data && res.data.records) || []
        this.list = append ? this.list.concat(records) : records
        this.total = (res.data && res.data.total) || 0
        if (!append) this.page.pageCurrent = 1
      }).catch(() => {
        this.resetVerify()
      }).finally(() => { this.loading = false })
    },
    loadMore() {
      this.page.pageCurrent += 1
      this.fetchList(true)
    },
    switchPhone() {
      this.resetVerify()
      this.$toast('请重新验证手机号')
    },
    resetVerify() {
      localStorage.removeItem(PHONE_KEY)
      this.verifiedPhone = ''
      this.list = []
      this.total = 0
      this.phone = ''
      this.code = ''
      this.page.pageCurrent = 1
    }
  }
}
</script>

<style scoped>
.mall-h5 {
  min-height: 100vh;
  background: #F8F4F0;
  padding-bottom: 30px;
  -webkit-font-smoothing: antialiased;
}

/* ===== 品牌头(与商城首页一致) ===== */
.mh5-banner {
  position: relative;
  background: linear-gradient(135deg, #6B1A1A 0%, #8B2222 40%, #5C1010 100%);
  color: #fff;
  padding: 22px 20px 20px;
  overflow: hidden;
  border-bottom-left-radius: 18px;
  border-bottom-right-radius: 18px;
}
.mh5-banner__pattern {
  position: absolute;
  top: -40px;
  right: -30px;
  width: 160px;
  height: 160px;
  border: 2px solid rgba(255,255,255,0.08);
  border-radius: 50%;
  pointer-events: none;
}
.mh5-banner__pattern::after {
  content: '';
  position: absolute;
  top: 20px;
  left: 20px;
  right: 20px;
  bottom: 20px;
  border: 1px solid rgba(255,255,255,0.06);
  border-radius: 50%;
}
.mh5-banner__phone {
  position: absolute;
  top: 14px;
  right: 12px;
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  font-weight: 500;
  color: #F0D9A0;
  background: rgba(255,255,255,0.14);
  padding: 5px 11px;
  border-radius: 14px;
  z-index: 2;
  cursor: pointer;
}
.mh5-banner__phone i:first-child { font-size: 13px; }
.mh5-banner__phone i:last-child { font-size: 12px; opacity: 0.8; margin-left: 2px; }
.mh5-banner__content {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.mh5-banner__logo-img {
  width: 64%;
  max-width: 260px;
  height: auto;
  display: block;
  filter: brightness(1.05);
}
.mh5-banner__text-group {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 10px;
}
.mh5-banner__sub {
  font-size: 11px;
  color: rgba(232, 200, 130, 0.75);
  letter-spacing: 4px;
  text-indent: 4px;
}
.mh5-banner__slogan {
  margin-top: 5px;
  font-size: 15px;
  font-weight: 600;
  color: #F0D9A0;
  letter-spacing: 5px;
  text-indent: 5px;
}
.mh5-banner__decor {
  position: absolute;
  bottom: 12px;
  right: 20px;
  display: flex;
  align-items: center;
  gap: 6px;
  z-index: 1;
}
.mh5-banner__decor-dot {
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: rgba(255,255,255,0.3);
}
.mh5-banner__decor-line {
  width: 24px;
  height: 1px;
  background: rgba(255,255,255,0.2);
  margin-left: 4px;
}

/* ===== 验证区 ===== */
.mh5-verify {
  padding: 18px 16px 0;
}
.mh5-verify__card {
  background: #fff;
  border-radius: 16px;
  padding: 26px 22px 22px;
  box-shadow: 0 6px 24px rgba(107,26,26,0.08);
}
.mh5-verify__icon {
  width: 54px;
  height: 54px;
  border-radius: 50%;
  background: linear-gradient(135deg, #C0392B, #A3312A);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 26px;
  margin: 0 auto 14px;
  box-shadow: 0 4px 14px rgba(192,57,43,0.3);
}
.mh5-verify__icon .van-icon {
  font-size: inherit;
  color: inherit;
}
.mh5-verify__title {
  font-size: 19px;
  font-weight: 700;
  color: #3C3C3C;
  text-align: center;
}
.mh5-verify__desc {
  font-size: 12px;
  color: #B0A89E;
  text-align: center;
  margin: 8px 0 22px;
  line-height: 1.7;
}
.mh5-verify__form { display: flex; flex-direction: column; gap: 13px; }
.mh5-field {
  display: flex;
  align-items: center;
  background: #F8F4F0;
  border-radius: 10px;
  padding: 12px 14px;
  border: 1px solid #F0ECE6;
  transition: border-color 0.2s, background 0.2s;
}
.mh5-field:focus-within { border-color: #C0392B; background: #fff; }
.mh5-field i { color: #B0A89E; font-size: 16px; margin-right: 10px; }
.mh5-field input {
  flex: 1;
  border: none;
  background: transparent;
  outline: none;
  font-size: 15px;
  color: #3C3C3C;
  min-width: 0;
}
.mh5-field--code input { flex: 1; }
.mh5-codebtn {
  flex-shrink: 0;
  border: none;
  background: transparent;
  color: #C0392B;
  font-size: 13px;
  font-weight: 600;
  padding: 0 4px 0 12px;
  border-left: 1px solid #E8E3DA;
  cursor: pointer;
  white-space: nowrap;
}
.mh5-codebtn:disabled { color: #C4BDB3; cursor: not-allowed; }
.mh5-submit {
  margin-top: 6px;
  height: 46px;
  border: none;
  border-radius: 23px;
  background: linear-gradient(135deg, #C0392B, #A3312A);
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 1px;
  box-shadow: 0 6px 16px rgba(192,57,43,0.28);
  cursor: pointer;
  transition: opacity 0.2s;
}
.mh5-submit:active { opacity: 0.9; }
.mh5-submit:disabled {
  background: #E0D6CF;
  box-shadow: none;
  cursor: not-allowed;
}

/* ===== 订单列表 ===== */
.mh5-orders { padding: 16px 14px 0; }
.mh5-order {
  background: #fff;
  border-radius: 14px;
  padding: 14px 14px 12px;
  margin-bottom: 12px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.05);
  cursor: pointer;
  transition: box-shadow 0.15s;
}
.mh5-order:active { box-shadow: 0 1px 6px rgba(0,0,0,0.08); }
.mh5-order__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 10px;
  border-bottom: 1px solid #F5F1EB;
}
.mh5-order__no { font-size: 12px; color: #999; }
.mh5-order__status { font-size: 12px; font-weight: 600; padding: 2px 9px; border-radius: 10px; }
.mh5-order__status.is-wait { color: #C9A96E; background: rgba(201,169,110,0.14); }
.mh5-order__status.is-paid { color: #fff; background: linear-gradient(135deg, #C0392B, #A3312A); }
.mh5-order__status.is-ship { color: #fff; background: linear-gradient(135deg, #C9A96E, #B8944E); }
.mh5-order__status.is-refund { color: #909399; background: rgba(144,147,153,0.14); }
.mh5-order__status.is-cancel { color: #909399; background: rgba(144,147,153,0.14); }
.mh5-order__status.is-confirm { color: #409eff; background: rgba(64,158,255,0.12); }

.mh5-order__foot {
  display: flex;
  align-items: center;
  padding-top: 10px;
  border-top: 1px solid #F5F1EB;
}
.mh5-order__time { font-size: 11px; color: #B0A89E; flex: 1; }
.mh5-order__total { font-size: 12px; color: #666; margin-right: 6px; }
.mh5-order__total b { color: #C0392B; font-size: 15px; }
.mh5-order__arrow { font-size: 14px; color: #C4BDB3; }

/* ===== 空状态 & 更多 ===== */
.mh5-empty { text-align: center; padding: 70px 0; }
.mh5-empty__icon {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: #F0ECE6;
  margin: 0 auto 14px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.mh5-empty__icon i { font-size: 28px; color: #C4BDB3; }
.mh5-empty__text { font-size: 14px; color: #999; margin-bottom: 5px; }
.mh5-empty__hint { font-size: 12px; color: #C4BDB3; }
.mh5-more {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  text-align: center;
  color: #B0A89E;
  font-size: 13px;
  padding: 14px 0 4px;
  cursor: pointer;
}
.mh5-more i { font-size: 12px; }

.mh5-safe-bottom { height: 12px; }
</style>
